export default __webpack_public_path__ + "static/media/f2.5f5a023f.svg";